import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[YieldMgmt.LegPricingAudit] Load';
export const LOAD_SUCCESS = '[YieldMgmt.LegPricingAudit] Load Success';
export const LOAD_FAIL = '[YieldMgmt.LegPricingAudit] Load Fail';
export const RESET = '[YieldMgmt.LegPricingAudit] Reset';

export class LoadPayload {
  constructor(public page: number, public itemsPerPage: number) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(
    public items: Array<models.LegPriceAudit>,
    public page: number,
    public count: number
  ) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction | ResetAction;
